import React, { useEffect, useRef, useState } from 'react';
import { useLocale } from '../context/LocaleContext';
import './LanguageSwitcher.css';

const OPTIONS = [
  { code: 'es', shortKey: 'lang.es' },
  { code: 'en', shortKey: 'lang.en' },
];

export default function LanguageSwitcher({ className = '' }) {
  const { locale, setLocale, t } = useLocale();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const current = OPTIONS.find((o) => o.code === locale) || OPTIONS[0];

  useEffect(() => {
    if (!open) return;

    const onDocDown = (e) => {
      if (rootRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', onDocDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const pickLocale = (code) => {
    setLocale(code);
    setOpen(false);
  };

  return (
    <div
      ref={rootRef}
      className={`lang_switch${open ? ' lang_switch--open' : ''}${
        className ? ` ${className}` : ''
      }`}
    >
      <button
        type="button"
        className="lang_switch_trigger"
        aria-label={t('lang.switchLabel')}
        aria-haspopup="listbox"
        aria-expanded={open ? 'true' : 'false'}
        onClick={() => setOpen((v) => !v)}
      >
        {t(current.shortKey)}
      </button>

      {open ? (
        <ul className="lang_switch_menu" role="listbox" aria-label={t('lang.menuLabel')}>
          {OPTIONS.map(({ code, shortKey }) => {
            const active = locale === code;
            return (
              <li key={code} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={active ? 'true' : 'false'}
                  className={`lang_switch_option${active ? ' lang_switch_option--active' : ''}`}
                  onClick={() => pickLocale(code)}
                >
                  {t(shortKey)}
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
